if (!daz) {
    var daz = {};
}
if (!daz.nfpets) {
    daz.nfpets = {};
}

daz.nfpets.sparky = (function (address) {

    let contract = null;
    function init() {
        contract = new window.dazeth.web3.eth.Contract(window.dazContracts["NFPetsSparky"], address);
    }

    const nfpsAllowed = async function (tokens) {
        if (tokens.length === 0) {
            return [];
        }
        return hasRedeemedSparky(tokens).then(hasRedeemed => {
            const allowed = [];
            for (const i in hasRedeemed) {
                if (hasRedeemed[i]) {
                    continue;
                }
                allowed.push(tokens[i]);
            }
            return allowed;
        });
    }

    const nfpsWith = async function (tokens) {
        if (tokens.length === 0) {
            return [];
        }
        return hasRedeemedSparky(tokens).then(hasRedeemed => {
            const allowed = [];
            for (const i in hasRedeemed) {
                if (!hasRedeemed[i]) {
                    continue;
                }
                allowed.push(tokens[i]);
            }
            return allowed;
        });
    }

    const mint = async function(tokens, onTransactionHash) {
        init();
        return contract.methods.batchMintSparky(tokens).send({
            from: dazethutil.me(),
        }).on('transactionHash', (hash) => onTransactionHash(hash));
    }

    const hasRedeemedSparky = async function(tokens) {
        init();
        return contract.methods.hasRedeemedSparky(tokens).call();
    }

    return {
        NfpsAllowed: nfpsAllowed,
        NfpsWith: nfpsWith,
        Mint: mint
    }
})(window.nfpetsConfig.pets.sparky);
